<!--Documentation-->
<!-----------------
1. Import: 
import ColorPicker from "@/components/FormElements/ColorPicker.vue";
------------------------------------------------
2. Template:
 <color-picker
     colorRef="header-col"
     colorId="header-col"
     label="Primary Colour"
     defaultValue="#ffffff"
     @change="handleColChange"
     ref="header-colour"
     :disabled="false"
 ></color-picker>

---------------------------------------------------
3. Get Input Colour: 
 handleColChange(val) {
 }

--------------------------------------------------
4. To Update Colour on Run time:
this.$refs["header-colour"].updateColor("#776444");

----------------->

<template>
  <div>
    <b-row style="position: relative"
      ><div class="disabled" v-if="disabled"></div>
      <b-col md="1">
        <input
          class="theme"
          :id="colorId"
          :ref="colorRef"
          type="color"
          @input="colorChange"
          v-model="colorV" /></b-col
      ><b-col md="8">
        <c-input
          class="mt-3 color-input"
          inputType="text"
          :id="colorId + '2'"
          v-model="colorV"
          @input="colorChange"
          :lableText="label"
      /></b-col>
      <b-col md="2">
        <b-button class="icon btn-primary" id="theme2" @click="$refs[colorRef].click()"
          ><img src="@/assets/images/color_picker.svg" id="theme2" alt=""
        /></b-button> </b-col
    ></b-row>
  </div>
</template>

<script>
import cInput from "@/components/FormElements/CustomInput";
export default {
  props: {
    colorRef: {
      type: String,
      default: "color-ref",
    },

    colorId: {
      type: String,
      default: "color-1",
    },
    label: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { cInput },
  data() {
    return {
      startDate: "",
      endDate: "",
      colorV: "",
    };
  },
  methods: {
    colorChange(e) {
      if (typeof e == "string") this.$emit("change", e);
      else this.$emit("change", e.target.value);
    },
    updateColor(col) {
      this.colorV = col;
    },
  },
  watch: {
    defaultValue(val) {
      this.colorV = val;
    },
  },
  mounted() {
    this.colorV = this.defaultValue;
  },
};
</script>
<style lang="scss" scoped>
.theme {
  height: 47px;
  margin-top: -3px;
  width: 53px;
}

.color-input {
  width: 115% !important;
  margin-left: 7px !important;
  height: 40px !important;
  margin-top: 1px !important;
}

.icon {
  height: 38px !important;
  margin-left: 0 !important;
  margin-top: 1px;
}

.slug-name {
  width: 380px !important;
}
.disabled {
  position: absolute;
  width: 90%;
  height: 100%;
  z-index: 2;
  margin-left: 10px;
  background: #c2c2c22f;
}
</style>
